/* Glanzlabor – Warenkorb-Upsell */
(function () {
if (window.__glanzInit) return;
window.__glanzInit = true;
async function addLines(lines) {
var actions = window.Shopify && window.Shopify.actions;
if (actions && actions.updateCart) {
try {
var res = await actions.updateCart({ lines: lines.map(function (l) { return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.quantity || 1 }; }) });
if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
if (actions.openCart && document.querySelector('cart-drawer-component')) await actions.openCart();
return;
} catch (e) { console.warn('[glanz] updateCart fehlgeschlagen', e); }
}
var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines.map(function (l) { return { id: Number(l.id), quantity: l.quantity || 1 }; }) }) });
if (!r.ok) throw new Error('Hinzufügen fehlgeschlagen');
window.location.href = '/cart';
}
document.addEventListener('click', async function (e) {
var btn = e.target.closest('[data-glanz-add]');
if (!btn) return;
e.preventDefault();
if (btn.disabled) return;
var label = btn.textContent;
btn.disabled = true;
btn.textContent = 'Wird hinzugefügt …';
try { await addLines([{ id: btn.getAttribute('data-glanz-add'), quantity: 1 }]); }
catch (err) { window.location.href = '/cart'; }
finally { btn.disabled = false; btn.textContent = label; }
});
})();
